export class Empresa{

  constructor(
    public nombrempresa: string,
    public nombrecliente: string,
    public apellido: string,
    public email: string,
    public telefono: string,
    public celular: string,
    public direccionweb: string,
    public direccion: string,
    public ciudad: string,
    public estado: string,
    public pais: string,
    public zipcode: string,
    public password?: string,
    public emailpersonal?: string,
    public prioridad?: number,
    public alias?: string,
    public role?: string,
    public colorrepresentativo?: string,
    public activado?: boolean,
    public avisoPrivacidadAceptado?: boolean,
    public avisoPrivacidadVersion?: string,
    public avisoPrivacidadAceptadoEn?: Date,
    public _id?: string,
    public usermx?: string,
    public validaformato?: boolean,
    public firmatemporaldia? : boolean,
    public firmatemporalsem? : boolean,
    public firmatemporalmes? : boolean,
    public firmatemporalano? : boolean,
    public firmatemporalexc? : boolean,

    
    
      ) {}
}


